import { isPlanSelectableForTraderStatus } from '../SubscriptionPlanCatalogModel/rules';
import type { SubscriptionPlan } from '@thinkalpha/access-ws-client/contracts/subscription.js';
import { SUBSCRIPTION_PLAN_ADVERTISING_SLUGS } from 'src/lib/subscription/advertisingSlugs';

export function findDefaultPlan(
    plans: readonly SubscriptionPlan[],
    isProfessionalTrader: boolean,
): SubscriptionPlan | undefined {
    const selectablePlans = plans.filter((plan) => isPlanSelectableForTraderStatus(plan, isProfessionalTrader));

    return (
        selectablePlans.find((plan) =>
            plan.advertisingSlugs.includes(SUBSCRIPTION_PLAN_ADVERTISING_SLUGS.defaultSelected),
        ) ??
        selectablePlans.find((plan) => plan.default) ??
        selectablePlans[0]
    );
}
